import { ShapeState } from '../../../../../../cross-team-shared/annotation/shared/state/shape-state';
import { flipYCoordinate } from './orthographic-orchestrator';

export function flipShapeYCoordinates<T extends ShapeState>(shape: T) {
  return {
    ...shape,
    key_locations: shape.key_locations.map((keyLocation) => ({
      ...keyLocation,
      points: keyLocation.points.map(flipYCoordinate),
    })),
  };
}
